import { render } from "./BankConnect.vue?vue&type=template&id=d18163a4&scoped=true"
import script from "./BankConnect.vue?vue&type=script&lang=js"
export * from "./BankConnect.vue?vue&type=script&lang=js"

import "./BankConnect.vue?vue&type=style&index=0&id=d18163a4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18163a4"]])

export default __exports__